import React from 'react';
import Pricing from '../components/Pricing';
import Navigation from '../components/Navigation';

export default function PricingPage() {
  return (
    <div className="min-h-screen">
      <Navigation />
      <main className="py-10">
        <div className="mx-auto max-w-7xl sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold mb-8 theme-text-primary">Pricing Plans</h1>
          <Pricing />
        </div>
      </main>
    </div>
  );
}
